import AccordionItem from '@monofront/design-system/components/Accordion';
import Button from '@monofront/design-system/components/Button';
import PrismicLink from '@components/PrismicLink';
import { PrismicRichText } from '@components/PrismicRichText';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapFaq } from './mapFaq';
import { IFaq } from './types';
import { PrismicTitle } from '@components/PrismicTitle';

const FAQ: React.FC<IFaq> = ({
  title,
  titleStyle,
  items,
  ctaText,
  ctaLink,
}) => {
  if (!items || !items.length) return null;

  return (
    <section
      className="tw-m-auto tw-flex tw-w-auto tw-max-w-[600px] tw-flex-col tw-items-center desktop:tw-w-[80%]"
      data-testid="slice-faq"
    >
      <PrismicTitle field={title} titleStyleField={titleStyle} />
      <div className="tw-my-8 tw-w-full">
        {items.map((item, index) => {
          if (!item.accordionContent) {
            return null;
          }

          return (
            <AccordionItem
              key={index}
              title={item.accordionTitle!}
              preventScroll
            >
              <div className="tw-py-2">
                <PrismicRichText field={item.accordionContent} />
              </div>
            </AccordionItem>
          );
        })}
      </div>
      {ctaText && ctaLink && ctaLink.link_type !== 'Any' && (
        <PrismicLink link={ctaLink}>
          <Button hasMinWidth={false} block={false}>
            {ctaText}
          </Button>
        </PrismicLink>
      )}
    </section>
  );
};

export default withSlice(FAQ, mapFaq);
